import type { FunctionComponent } from 'react';
import styled, { useTheme } from 'styled-components';
import { paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { convertHexStringToRGBA } from '../../../../../app-kit/helpers/convertHexStringToRGBA';
import { useMediaGalleryLightBoxContext } from '../../../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { DefineAdSlot } from '../../../../../app-kit/components/DefineAdSlot/DefineAdSlot';
import { mapSlotConfigFromVariant } from './helpers/mapSlotConfigFromVariant';
import { isHopefullyDomEnvironment } from '../../../../../helpers/IsHopefullyDomEnvironment';
import { getCssVariableValue } from '../../../../../app-kit/helpers/getCssVariableValue';

const minWidthPx = 1280;
const minHeightPx = 608;
const adWidthPx = 160;
const adHeightPx = 600;

const AdvertisementContainer = styled.div<{ $leftBorderColor: string }>`
  display: none;

  @media (min-width: ${minWidthPx}px) and (min-height: ${minHeightPx}px) {
    width: calc(${adWidthPx}px + ${spacingHelper('extraLarge')} * 2);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid ${(props) => props.$leftBorderColor};
    /* adding 1px transparent border right so content is still centered */
    border-right: 1px solid transparent;
  }
`;

const SlotWrapper = styled.div`
  width: ${adWidthPx}px;
  height: ${adHeightPx}px;
  background-color: ${paletteHelper('backgroundSecondaryInvertedStatic')};
`;

export const MediaGalleryDesktopAd: FunctionComponent = () => {
  const theme = useTheme();
  const colourValue = getCssVariableValue(theme.palette.borderPrimary);
  const leftBorderColor = convertHexStringToRGBA(colourValue, 0.3);

  const { propertyPageBySlugData } = useMediaGalleryLightBoxContext();

  const desktopAd = propertyPageBySlugData?.mediaGalleryV2?.desktopAd;

  if (
    !desktopAd ||
    !isHopefullyDomEnvironment() ||
    window.innerWidth < minWidthPx ||
    window.innerHeight < minHeightPx
  ) {
    return null;
  }

  return (
    <AdvertisementContainer data-testid="MediaGalleryDesktopAd" $leftBorderColor={leftBorderColor}>
      <SlotWrapper>
        <DefineAdSlot slotConfig={mapSlotConfigFromVariant(desktopAd.variant)} />
      </SlotWrapper>
    </AdvertisementContainer>
  );
};
